// removed by extract-text-webpack-plugin
module.exports = {"blog-intro":"main_nav-2ob","header":"main_nav-26u","description":"main_nav-2i4"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/MainNav/Submenu/Intro/Blog/blog_intro.module.scss
// module id = 356
// module chunks = 0